import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'

export const createSectionHighlightsProjection = (localeId: LocaleId) => {
  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        highlights[]{
           _key,
          ${coalesceLocaleField('title', localeId)},
          ${coalesceLocaleField('description', localeId)},
        },
        spacing,
        topBorder,
      }
  `
}
